import Control from "@/Controls/Control";
import ComponentManager from "@/Management/ComponentManager";
import StartpageElementViewModelType from "@/ViewModels/Controls/StartpageElementViewModel";
import LabelType from "@/Controls/Label";
import LinkType from "@/Controls/Link";
import ImageType from "@/Controls/Image";

export default class StartpageElement extends Control {
  private Label = ComponentManager.getControl<typeof LabelType>("Label");
  private Link = ComponentManager.getControl<typeof LinkType>("Link");
  private Image = ComponentManager.getControl<typeof ImageType>("Image");
  protected jQueryControl: JQuery;
  private items: Array<LinkType>;
  private image: ImageType;
  private label: LabelType;

  public constructor(
    private viewModel: StartpageElementViewModelType,
    private element?: JQuery,
  ) {
    super(viewModel, element);

    this.onWidgetCreated(this.onWidgetCreatedCallback.bind(this));
  }

  public getControl(): JQuery {
    if (this.jQueryControl != null) {
      return this.jQueryControl;
    }

    this.jQueryControl = this.element || $("<div>");

    this.widget(null);

    return this.jQueryControl;
  }

  protected onWidgetCreatedCallback(widget: null): void {
    this.applyBindings(this.jQueryControl, {
      controlName: "startpageelement",

      loader: this.viewModel.isBusy,

      controlIdent: this.identifier,

      tooltip: this.viewModel.tooltip,

      invalid: this.viewModel.invalidationText,

      styles: this.definePureComputed({
        read: () => {
          let styles = ["default"];

          return styles;
        },
      }),

      states: this.definePureComputed({
        read: () => {
          let states = [];

          if (this.viewModel.isRequired() === true) {
            states.push("required");
          }

          return states;
        },
      }),
    });

    if (this.viewModel.label != null) {
      this.label = new this.Label(this.viewModel.label);
      let tuple = this.label.getTuple();

      tuple.control.prependTo(this.jQueryControl);
    }

    if (this.viewModel.image != null) {
      this.image = new this.Image(this.viewModel.image);
      let tuple = this.image.getTuple();

      tuple.control.prependTo(this.jQueryControl);
    }

    let items = this.viewModel.items();
    this.items = [];

    for (let item of items) {
      let link = new this.Link(item, $("<a>").appendTo(this.jQueryControl));
      let tuple = link.getTuple();

      this.items.push(link);
    }
  }
}

ComponentManager.setControl(
  "StartpageElement",
  StartpageElement,
  "RADPresentation.HTMLClient.DefaultViewExtensions",
);
